<script>
  export let tipoEvaluacion;

  import { onMount } from "svelte";
  import { copyObject } from "../../js/copyObject";
  import { post } from "../../js/api";
  import Questionnaire from "../../components/Questionnaire.svelte";
  import QuestionnaireRemaining from "../../components/QuestionnaireRemaining.svelte";
  import { navigate } from "svelte-routing";

  import { getToken, getCenter } from "../../js/local";

  let centerList = [];
  let centerListSelected = null;
  let questionnaireList = [];
  let questionnaireListFiltered = [];
  let word = "";

  const token = getToken();
  const center = getCenter();

  let estadoSel = "realizada";

  let loading = true;

  onMount(async () => {
    await getCenters();
    //await getQuestionnaire();
  });

  let getCenters = async () => {
    loading = true;
    const response = await post(
      "ObtenerCentros",
      {
        token,
        tipoEvaluacion,
      },
      "json"
    );
    centerList = response.map((center) => {
      center.label = center.nombre;
      center.value = center.codigo;
      return center;
    });

    if (center !== "0") {
      centerList = centerList.filter((item) => {
        return item.value === center;
      });
    }
    if (centerList.length > 0) {
      centerListSelected = centerList[0];
    }

    centerList = centerList;

    if (estadoSel == "realizada") {
      getQuestionnaire();
    } else {
      getQuestionnaireRemaining();
    }
    loading = false;
  };

  let getQuestionnaire = async () => {
    loading = true;
    word = "";
    questionnaireList = [];
    questionnaireList = await post(
      "ObtenerCuestionariosFinalizadosPorCentro",
      {
        codigoCentro: centerListSelected.value,
        token,
        tipoEvaluacion,
      },
      "json"
    );
    questionnaireListFiltered = copyObject(questionnaireList);
    loading = false;
  };

  let getQuestionnaireRemaining = async () => {
    loading = true;
    word = "";
    questionnaireList = [];
    questionnaireList = await post(
      "ObtenerCuestionariosNoFinalizadosPorCentro",
      {
        codigoCentro: centerListSelected.value,
        token,
        tipoEvaluacion,
      },
      "json"
    );
    questionnaireListFiltered = copyObject(questionnaireList);
    loading = false;
  };

  let filterQuestionnaire = () => {
    questionnaireListFiltered = copyObject(questionnaireList);
    if (word !== "") {
      questionnaireListFiltered = questionnaireListFiltered.filter((c) => {
        return (
          c._profesor_.toLowerCase().includes(word.toLowerCase()) ||
          c._profesorCod_.toLowerCase().includes(word.toLowerCase())
        );
      });
    }
  };

  $: if (word !== "") {
    filterQuestionnaire();
  } else {
    questionnaireListFiltered = copyObject(questionnaireList);
  }

  $: console.log(estadoSel);
</script>

<div class="mainbody">
  <div class="header">
    <img
      src="images/logo-uex-white.png"
      loading="lazy"
      srcset="
            images/logo-uex-white-p-500.png 500w,
            images/logo-uex-white.png       780w
          "
      height="20"
      sizes="(max-width: 479px) 20vw, (max-width: 767px) 61.111114501953125px, (max-width: 991px) 9vw, 85.56713104248047px"
      alt=""
      class="logoheader listadocuestionarios"
    />
    <div class="headertitletxt leftalign nomargin">
      Listado de <strong>cuestionarios</strong>
    </div>
  </div>
  <div class="bodylistado">
    <div class="listadoselect">
      <div class="selectform w-form">
        <div
          id="email-form"
          name="email-form"
          data-name="Email Form"
          method="get"
          class="selectformitem"
        >
          <label for="field-2" class="field-label">Centro</label>
          <select
            class="select-field w-select aux-1"
            bind:value={centerListSelected}
            on:change={async () => {
              if (estadoSel == "realizada") {
                getQuestionnaire();
              } else {
                getQuestionnaireRemaining();
              }
            }}
          >
            {#each centerList as center}
              <option value={center} selected={centerListSelected}>
                {center.label}
              </option>
            {/each}
          </select>
        </div>
      </div>
      <div class="selectform w-form">
        <div
          id="email-form"
          name="email-form"
          data-name="Email Form"
          method="get"
          class="selectformitem"
        >
          <label for="field-2" class="field-label">Estado</label>
          <select
            class="select-field w-select aux-1"
            bind:value={estadoSel}
            on:change={async () => {
              if (estadoSel == "realizada") {
                getQuestionnaire();
              } else {
                getQuestionnaireRemaining();
              }
            }}
          >
            <option value="realizada" selected>Realizada</option>
            <option value="noRealizada">No realizada</option>
          </select>
        </div>
      </div>
      <div action="/search" class="search w-form">
        <label for="search" class="field-label">Buscar</label>
        <input
          type="search"
          class="select-field w-input aux-1"
          maxlength="256"
          name="query"
          placeholder="Búsqueda..."
          id="search"
          bind:value={word}
        />
        <div
          class="greenbuttonstyle searchbutton w-button"
          on:click={() => {
            filterQuestionnaire();
          }}
        >
          Buscar
        </div>
      </div>
    </div>
    <div class="listadoresults">
      <div class="titletxt">
        {#if loading}
          <strong class="bold-text">Cargando</strong> datos...
        {:else}
          <strong class="bold-text">Resultados</strong> encontrados ({questionnaireListFiltered.length})
        {/if}
      </div>
      {#if estadoSel == "realizada"}
        {#each questionnaireListFiltered as questionnaire}
          <div class="questionnaireList"><Questionnaire {questionnaire} /></div>
        {/each}
      {:else}
        {#each questionnaireListFiltered as questionnaire}
          <div class="questionnaireList">
            <QuestionnaireRemaining {questionnaire} />
          </div>
        {/each}
      {/if}
      <div class="search w-form">
        <div
          class="greenbuttonstyle searchbutton w-button volver"
          on:click={() => navigate("/inicio")}
        >
          Volver
        </div>
      </div>
      <img
        src="images/logo-uex-complete-black.png"
        loading="lazy"
        width="300"
        srcset="
              images/logo-uex-complete-black-p-500.png   500w,
              images/logo-uex-complete-black-p-800.png   800w,
              images/logo-uex-complete-black-p-1080.png 1080w,
              images/logo-uex-complete-black-p-1600.png 1600w,
              images/logo-uex-complete-black-p-2000.png 2000w,
              images/logo-uex-complete-black-p-2600.png 2600w,
              images/logo-uex-complete-black-p-3200.png 3200w,
              images/logo-uex-complete-black.png        3994w
            "
        sizes="(max-width: 479px) 88vw, 249.98843383789062px"
        alt=""
        class="logobottom"
      />
    </div>
  </div>
</div>

<style>
  .questionnaireList {
    display: flex;
    flex-direction: column;
  }

  .logobottom {
    margin-top: 0px;
  }

  div.volver {
    margin-bottom: 35px;
  }
</style>
